// For more info visit https://usehooks-typescript.com/react-hook/use-debounce
import { useEffect, useState } from 'react';

export const useDebounce = <T> (value: T, delay?: number): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay || 500);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
};
